import {createContext} from "react";

export const CollepsedContext = createContext({
    collespsed: true,
    setCollespsed: ()=>{}
});